<template>
  <LoadingWrapper :state="status">
    <PreparePulseSlideAnalysis
      :all-surveys="data.surveys"
      :feedback-topic="data.feedbackTopic"
      :slide-properties="data.slideProperties"
      @dirty="setDirty"
    />
    <UnsavedChangesDialog
      :is-open="showConfirmDialog"
      @confirm="confirmLeave"
      @dismiss="cancelLeave"
    />
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { usePreparePulseSlide } from '../composable/use-prepare-pulse-slide'
  import PreparePulseSlideAnalysis from './PreparePulseSlideAnalysis.vue'
  import { useRoute } from 'vue-router'
  import { computed } from 'vue'
  import { useUnsavedChanges } from '@/core/composables/use-unsaved-changes'
  import UnsavedChangesDialog from '@/core/components/unsaved-changes-dialog/UnsavedChangesDialog.vue'

  const route = useRoute()
  const feedbackTopicId = computed(() => route.params.feedbackTopicId as string)
  const { status, data } = usePreparePulseSlide(feedbackTopicId)

  const { showConfirmDialog, confirmLeave, cancelLeave, setDirty } = useUnsavedChanges()
</script>
